export const selectAllHandler = (
  data,
  name,
  isLocationSelected,
  isSpecificLocationSelected,
  isAllSelected,
) => {
  // =======logic============
  // clicking "all" toggles it, so write the flipped value everywhere
  const select = !isAllSelected;

  // 2. update all locations
  const locationArr = isLocationSelected.map((location) => select);
  const locationDispatchObj = {
    controller: name,
    arr: locationArr,
  };
  // 3.update all isSpecificLocationSelected
  const specificLocationArr = isSpecificLocationSelected.map((el) =>
    el.map((specLocationState) => select),
  );
  const specLocationDispatchObj = {
    controller: name,
    arr: specificLocationArr,
  };
  // 4. update all machines

  const individualArr = Object.values(data)?.map((location, i) => {
    if (location.isSpecificLocation) {
      return Object.values(location.subLocations).map((subLocation) => {
        Object.values(subLocation.devices).map((machine) => {
          return select;
        });
      });
    } else {
      return Object.values(location.devices).map((machine) => {
        return select;
      });
    }
  });

  // const individualArr = Object.values(data)?.map((location,i) => {

  //   const locationArr = Object.values(location);

  //   if (!locationArr[0]) {
  //     return Object.keys(locationArr[1]).map((machine) => true)
  //   } else {
  //     return Object.keys(locationArr[1]).map((SubLocation) => {
  //       return Object.keys(locationArr[1][SubLocation]).map((machine) => true)
  //     })
  //   }
  // });

  const machineDispatchObj = {
    controller: name,
    arr: individualArr,
  };
  return {
    locationList: locationDispatchObj,
    specificLocationList: specLocationDispatchObj,
    machineList: machineDispatchObj,
    select,
  };
};
